import { ActionTypes } from "../constants";

const reduceSurveyReports = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.GET_MSF_SURVEY_REPORT_SUCCESS:
            return {
                ...state,
                [action.payload.id]: action.data
            };

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getBySurvey = (surveyReports, surveyId) => !surveyReports ? null : surveyReports[surveyId];

export default reduceSurveyReports;
